package com.kaihuoy.components.common

import org.jetbrains.compose.web.css.*

object KaihuTheme {
    // Päävärit
    val Primary      = Color("#3B82F6")        // Blue 500
    val PrimaryLight = Color("#1e2235")         // korostus tumma
    val PrimaryTeal  = Color("#22d3ee")         // Cyan 400 — accent
    val Secondary    = Color("#F59E0B")         // Amber 500

    // Taustavärit — tumma teema
    val Background   = Color("#0f1120")         // tausta
    val Surface      = Color("#131625")         // korttipinta
    val CardBackground = Color("#1e2235")       // nostettu kortti

    // Tekstivärit
    val TextPrimary   = Color("#F1F5F9")        // Slate 100
    val TextSecondary = Color("#94A3B8")        // Slate 400
    val TextLight     = Color("#64748B")        // Slate 500

    // Tilavärit
    val Success = Color("#10B981")
    val Warning = Color("#F59E0B")
    val Danger  = Color("#EF4444")
    val SelDanger  = Color("#DC2626")
    val Info    = Color("#3B82F6")

    // Reunat
    val Border  = Color("#2a2f45")
    val Divider = Color("#1e2235")

    val HoverOverlay = rgba(255, 255, 255, 0.04)
    val OnPrimary    = Color("#FFFFFF")
    val OnSurface    = Color("#F1F5F9")

    val Green  = Color("#10B981")
    val Orange = Color("#F97316")
    val Amber  = Color("#F59E0B")
    val Grey   = Color("#475569")

    val ShadowSm = "0 1px 3px 0 rgba(0,0,0,0.4)"
    val ShadowMd = "0 4px 12px -2px rgba(0,0,0,0.5)"
    val ShadowLg = "0 12px 28px -4px rgba(0,0,0,0.6)"

    val CardGradient = "linear-gradient(135deg, #131625 60%, #0f1f2e 100%)"
    val TopBarGradient = "radial-gradient(circle at center, #0f1f2e 10%, #0f1120 70%)"
}

fun CSSColorValue.darken(percent: Int = 8): CSSColorValue = this
